import { SET_TIME_ENTRIES } from './actionType'

export function setTimeEntries(timeEntries) {
  return {
    type: SET_TIME_ENTRIES,
    timeEntries: timeEntries,
  }
}
